

  <div class="p-6 bg-white rounded-lg shadow-lg">
    <div class="flex items-end justify-end">
    <button id="modal-close-icon"  (click)="close()">
      <span class="text-lg material-symbols-rounded text-grey-800">close</span>
    </button>
    </div>

    <div class="flex flex-row">
    <h2 class="mx-1 mt-2 text-2xl font-medium text-left" id="modal-header">{{activeStep?.title}}</h2>
      <span class="ml-2 text-4xl material-symbols-rounded"
       [ngStyle]="{'color': activeStep?.iconColor}">{{activeStep?.icon}}</span>
    </div>
    <p class="mx-1 mt-2 text-left" id="modal-text">{{activeStep?.content}}</p>
    <div   class="flex justify-between mt-6">

      <button *ngIf="activeStep?.secondaryButtonText != null" id="secondary-button" (click)="secondaryButtonClick()" class="w-full px-4 py-2 mr-2 border border-gray-300 rounded-lg hover:bg-gray-100" >
        {{activeStep?.secondaryButtonText}}
      </button>
      <button  id="primary-button" (click)="primaryButtonClick()" class="w-full px-4 py-2 ml-2 rounded-lg btn btn-primary" >
        {{activeStep?.primaryButtonText}}
      </button>

    </div>
  </div>

